import { Injectable } from '@angular/core';
import { ModalService as DDSModalService } from '@usitsdasdesign/dds-ng/modal';

type ModalData = any | { [key: string]: any; isCanceled?: boolean; error?: any };

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private ddsModalService: DDSModalService) { }

  open(component: any, inputs?: { [key: string]: any }, enableEscForClosing?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      this.ddsModalService
        .open(component, inputs, enableEscForClosing)
        .onClosed()
        .subscribe((data: ModalData) => {
          if (!data || data.isCanceled) {
            reject(data && data.error);
          } else {
            resolve(data);
          }
        });
    });
  }

  close(data?: any): void {
    this.ddsModalService.close(data);
  }

  cancel(error?: any): void {
    this.ddsModalService.close({ error, isCanceled: true });
  }
}
